module.exports = __webpack_public_path__ + "img/music.7ac926a5.png";